const createOptionData = (data, uniqIdVideos) => {
    const mainData = {
        question: data.question,
    }
    let options = [];
    // create quiz info 
    [1, 2, 3, 4].forEach(num => {
        let singleOption = {
            id: num,
            option: data['option-' + num],
            isCorrect: data['isCorrect-' + num]
        };
        options = [...options, singleOption]
    })
    // adding options
    mainData.options = options

    if (data.video_id) {
        // id
        const videoId = parseInt(data.video_id)
        mainData.video_id = videoId
        // title 
        const video_title = uniqIdVideos.find(single => single.id === videoId).title
        mainData.video_title = video_title
    }
    return mainData
}

export const optionIdString = (id) => 'option-' + id;
export const correctIdString = (id) => 'isCorrect-' + id;
export default createOptionData